import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchedData, genFetchedData } from 'redux/fetchedData';
import {
  TCheckDynamicCatalogDataResult,
  TGetObjectionNextStepData,
  TGetReportData,
  TGetReportSettingsData,
  TGetReportsListData,
} from './types';

export interface ReportBuilderState {
  reportsTypeList: FetchedData<TGetReportsListData[]>;
  nextStepData: FetchedData<TGetObjectionNextStepData>;
  reportSettings: FetchedData<TGetReportSettingsData>;
  notExistInCatalogKeys: FetchedData<
    Record<string, TCheckDynamicCatalogDataResult>
  >;
  reportByFilter: FetchedData<TGetReportData>;
}

const initialState: ReportBuilderState = {
  reportsTypeList: genFetchedData<TGetReportsListData[]>(null),
  nextStepData: genFetchedData<TGetObjectionNextStepData>(null),
  reportSettings: genFetchedData<TGetReportSettingsData>(null),
  notExistInCatalogKeys:
    genFetchedData<Record<string, TCheckDynamicCatalogDataResult>>(null),
  reportByFilter: genFetchedData<TGetReportData>(null),
};

const ReportBuilderSlice = createSlice({
  name: 'creative',
  initialState,
  reducers: {
    setReportsList(
      state,
      action: PayloadAction<ReportBuilderState['reportsTypeList']>,
    ) {
      state.reportsTypeList = action.payload;
    },
    setNextStepData(
      state,
      action: PayloadAction<ReportBuilderState['nextStepData']>,
    ) {
      state.nextStepData = action.payload;
    },
    setReportSettings(
      state,
      action: PayloadAction<ReportBuilderState['reportSettings']>,
    ) {
      state.reportSettings = action.payload;
    },
    setNotExistInCatalogKeys(
      state,
      action: PayloadAction<ReportBuilderState['notExistInCatalogKeys']>,
    ) {
      state.notExistInCatalogKeys = action.payload;
    },
    setDefaultNotExistInCatalogKeys(state) {
      state.notExistInCatalogKeys =
        genFetchedData<Record<string, TCheckDynamicCatalogDataResult>>(null);
    },
    setClearReport(state) {
      state.reportByFilter = genFetchedData<TGetReportData>(null);
    },
    setClearNextStep(state) {
      state.nextStepData = genFetchedData<TGetObjectionNextStepData>(null);
    },
    setReportByFilter(
      state,
      action: PayloadAction<ReportBuilderState['reportByFilter']>,
    ) {
      state.reportByFilter = action.payload;
    },
  },
});

export const {
  setReportsList,
  setNextStepData,
  setReportSettings,
  setNotExistInCatalogKeys,
  setDefaultNotExistInCatalogKeys,
  setReportByFilter,
  setClearReport,
  setClearNextStep
} = ReportBuilderSlice.actions;
export const reportBuilderReducer = ReportBuilderSlice.reducer;
